import get from 'lodash/get';
import { definedValue } from '../utils';

export const isServer = () => Boolean(get(process, 'release.name'));

export const isSingleTypeFilter = (params) => {
  if (Object.keys(params).length !== 1 || !params.multiFacetedBoatTypeClass) {
    return false;
  }

  try {
    return JSON.parse(params.multiFacetedBoatTypeClass).length === 1;
  } catch (err) {
    return false;
  }
};

export const isSingleClassFilter = (params) => {
  if (Object.keys(params).length !== 1 || !params.multiFacetedBoatTypeClass) {
    return false;
  }

  try {
    const parsed = JSON.parse(params.multiFacetedBoatTypeClass);
    return parsed.length === 2 && parsed[1].length === 1;
  } catch (err) {
    return false;
  }
};

export const isSingleMakeFilter = (params) => {
  try {
    if (
      Object.keys(params).length === 1 &&
      params.multiFacetedMakeModel &&
      JSON.parse(params.multiFacetedMakeModel).length === 1
    ) {
      return true;
    }
  } catch (err) {
    return false;
  }

  return false;
};

export const isSingleModelFilter = (params) => {
  try {
    if (
      Object.keys(params).length === 1 &&
      params.multiFacetedMakeModel &&
      JSON.parse(params.multiFacetedMakeModel).length === 2 &&
      JSON.parse(params.multiFacetedMakeModel)[1].length === 1
    ) {
      return true;
    }
  } catch (err) {
    return false;
  }
  return false;
};

export const isSingleCountryFilter = (params) => {
  if (Object.keys(params).length === 1 && params.country) {
    return true;
  }
  return false;
};

export const isSingleStateFilter = (params) => {
  if (Object.keys(params).length === 2 && params.country && params.subdivision) {
    return true;
  }
  return false;
};

export const isSingleCityFilter = (params) => {
  if ( ['US', 'GB', 'AU', 'CA', 'ES', 'IT', 'FR'].includes(params.country) ){
    if (Object.keys(params).length === 3 && params.country && params.subdivision && params.city) {
      return true;
    }
  } else if (Object.keys(params).length === 2 && params.country && params.city) {
    return true;
  }
  return false;
};

export const showWordsmithContent = (params) => {
  if (isSingleClassFilter(params)) {
    return 'class';
  }
  if (isSingleMakeFilter(params)) {
    return 'make';
  }
  if (isSingleCountryFilter(params)) {
    return 'country';
  }
  if (isSingleStateFilter(params)) {
    return 'subdivision';
  }
  if (isSingleCityFilter(params)) {
    return 'city';
  }
  return undefined;
};

export const showRelatedBoatArticles = (params) => {
  if (isSingleModelFilter(params)) {
    return 'model';
  }
  if (isSingleMakeFilter(params)) {
    return 'make';
  }
  if (isSingleClassFilter(params)) {
    return 'class';
  }
  return undefined;
};

export const showVideos = (params) => {
  if (isSingleTypeFilter(params)) {
    return 'type';
  }
  if (isSingleClassFilter(params)) {
    return 'class';
  }
  if (isSingleMakeFilter(params)) {
    return 'make';
  }
  if (isSingleModelFilter(params)) {
    return 'model';
  }
  return undefined;
};

export const addUUIDToRecords = data => {
  if (data?.search?.records) {
    data.search.records = data.search.records.map(record => {
      record.UUID = Math.floor(Math.random() * 1000000000000000000);
      return record;
    });
  }

  if (data?.fuzzySponsoredBoats?.records) {
    data.fuzzySponsoredBoats.records = data.fuzzySponsoredBoats.records.map(record => {
      record.UUID = Math.floor(Math.random() * 1000000000000000000);
      return record;
    });
  }
};

const normalizeCategory = (category) => {
  return category
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatMooringsRecords = (moorings = []) => {
  return moorings.map((item) => {
    return {
      imageURL: definedValue(definedValue(item.media, []).find((media) => media.mediaType === "image")?.url, ''),
      description: normalizeCategory(item.category || ''),
      price: definedValue(item.price, {}),
      dimensions: definedValue(item.specifications?.dimensions, {}),
      owner: definedValue(item.owner?.displayName, ''),
      location: definedValue(item.owner?.location, {}),
      ownerLogo: definedValue(item.owner?.logos?.default, '')
    };
  });
};
